import { MenuItem } from '@components/dropdown';
import { RootUserMenu } from '@components/root-page-layout';
import { useCurrentUser } from 'client/lib/auth';

export function CalUserMenu() {
  const user = useCurrentUser();
  if (!user) {
    return null;
  }
  return (
    <RootUserMenu
      renderMenu={() => (
        <>
          {user.level !== 'student' && <MenuItem href="/calendar/bookings">My Bookings</MenuItem>}
          <MenuItem href="/calendar/settings">Settings</MenuItem>
          <MenuItem href={`/logout?goto=${encodeURIComponent('/calendar/login')}`}>Logout</MenuItem>
        </>
      )}
    />
  );
}
